import cn from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { AnalyticsToggler } from './AnalyticsToggler';
import { ANALYTICS_DATA_TYPE_CHANGED } from '../../../store/reducers/analytics';
import { DATA_TYPE_GMV, DATA_TYPE_UNITS } from '../../../constants/analytics';

import styles from './AnalyticsItemBox.module.scss';
import loaderStyles from '../../../stylesheets/scss/loader.module.scss';

export function AnalyticsItemBox(props) {
  const { metric, header, hasDataTypeSelector, largeSize, showLoader } = props;
  const dispatch = useDispatch();
  const dataType = useSelector((state) => state.analytics.metricsDataType[metric] || DATA_TYPE_GMV.value);

  const onChangeDataType = (dataType) => {
    if (!metric) return;
    dispatch({ type: ANALYTICS_DATA_TYPE_CHANGED, payload: { metric, dataType } });
  };

  return (
    <div
      className={cn(
        styles.wrapper,
        props.className,
        largeSize ? styles.largeSize : '',
        showLoader ? loaderStyles.wrapper : '',
      )}
    >
      <div className={styles.titleWrapper}>
        <h3 className={styles.title}>{props.title}</h3>
        {header}
        {hasDataTypeSelector && (
          <AnalyticsToggler
            selected={dataType}
            onChange={onChangeDataType}
            options={[
              { value: DATA_TYPE_GMV.value, label: DATA_TYPE_GMV.label },
              { value: DATA_TYPE_UNITS.value, label: DATA_TYPE_UNITS.label },
            ]}
          />
        )}
      </div>
      <div className={styles.children}>{props.children}</div>
    </div>
  );
}

AnalyticsItemBox.defaultProps = {
  hasDataTypeSelector: false,
  showLoader: false,
};

AnalyticsItemBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hasDataTypeSelector: PropTypes.bool,
  header: PropTypes.node,
  metric: PropTypes.string,
  title: PropTypes.string.isRequired,
  largeSize: PropTypes.bool,
  showLoader: PropTypes.bool,
};
